import { render, staticRenderFns } from "./NewAccessProfile.vue?vue&type=template&id=50d763b9"
import script from "./NewAccessProfile.vue?vue&type=script&lang=js"
export * from "./NewAccessProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports